import data from "./peptideHorizon.json";

export type HorizonPeptide = (typeof data.areas)[number]["peptides"][number];
export type HorizonGoal = (typeof data.areas)[number];
const COPY_REPLACEMENTS: Record<string, string> = {
  "Proposed HHS enforcement discretion for 503A compounding (not final; not FDA approval)": "Proposed, not final: HHS may let pharmacies custom-mix this. Not FDA-approved.",
  "Investigational (in clinical trials, not approved)": "In human trials. Not approved.",
  "Research-only (not approved for human use)": "Lab research only. Not approved for people.",
  "Triple-hormone agonist; the most anticipated next-gen weight drug.": "An experimental weekly shot that acts on three hormones. Being tested for weight loss.",
  "Dual GIP/GLP-1 drug (Zepbound/Mounjaro) with record weight-loss results.": "Weekly shot (Zepbound/Mounjaro) that acts on two hormones. FDA-approved for weight and type 2 diabetes.",
  "A stomach-derived peptide with striking animal data on gut and tissue repair; named in HHS's 2026 notice.": "A peptide first found in the stomach. Studied in animals for gut and tissue healing. Named in HHS's 2026 proposal.",
  "Mitochondria-made peptide studied as an 'exercise mimetic'; named in HHS's 2026 notice.": "Made by the cell's energy centers. Studied in animals for effects like exercise. Named in HHS's 2026 proposal.",
  "Master hormone signal studied for fertility and desire.": "A hormone signal studied for fertility and sex drive.",
};
export function horizonCopy(text: string) {
  return (COPY_REPLACEMENTS[text] ?? text).split("named in HHS's 2026 notice").join("named in HHS's 2026 proposal");
}
export const horizonData = data;
export const GOAL_LABELS: Record<string, string> = {
  metabolism: "Weight & Metabolism", brain: "Focus & Mood", skin: "Skin & Hair",
  gut: "Gut", joints: "Recovery & Joints", muscle: "Strength", sleep: "Sleep",
  immune: "Immunity", longevity: "Longevity", sexual: "Sexual health", bone: "Bone",
};
export const GOAL_ORDER = ["metabolism", "brain", "skin", "gut", "joints", "muscle", "sleep", "immune", "longevity", "sexual", "bone"];
export const horizonGoals = GOAL_ORDER.flatMap(id => data.areas.filter(a => a.id === id));
export const STAGE_ORDER = ["fda", "hhs", "inv", "supp", "cos", "res"];
export const STAGE_LABELS: Record<string, string> = {
  fda: "FDA-approved", hhs: "HHS proposal (not final)", inv: "In human trials",
  supp: "Dietary supplements", cos: "Cosmetic ingredients", res: "Lab research only",
};
export function isWatchStage(status: string) { return status === "hhs" || status === "inv"; }
export function sortHorizonPeptides(peptides: HorizonPeptide[]) {
  return [...peptides].sort((a, b) => STAGE_ORDER.indexOf(a.status) - STAGE_ORDER.indexOf(b.status));
}
export function legacyHorizonTarget(search: string, legacyGoal?: string) {
  const params = new URLSearchParams(search);
  const area = params.get("area");
  if (area !== null) { params.set("goal", area); params.delete("area"); }
  else if (legacyGoal && !params.has("goal")) params.set("goal", legacyGoal);
  const query = params.toString();
  return `/peptide-horizon${query ? `?${query}` : ""}`;
}